export const bodyPart = {
  MOUTH: 'MOUTH',
  NECK: 'NECK',
};
